import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Fetches products from dummyjson with correct server-side pagination.
 *
 * Important: the search endpoint (`/products/search`) also supports `limit`
 * and `skip`, so pagination keeps working while searching.
 */
export default function useProducts({ page = 1, limit = 12, search = '' } = {}) {
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const reload = useCallback(() => setReloadKey((key) => key + 1), []);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;

    const skip = (page - 1) * limit;
    const query = search.trim();

    const endpoint = query
      ? `/products/search?q=${encodeURIComponent(query)}&limit=${limit}&skip=${skip}`
      : `/products?limit=${limit}&skip=${skip}`;

    setLoading(true);
    setError(null);

    axios
      .get(endpoint, { signal: controller.signal })
      .then(({ data }) => {
        if (!active) return;
        setProducts(Array.isArray(data.products) ? data.products : []);
        setTotal(Number(data.total) || 0);
      })
      .catch((err) => {
        if (!active || axios.isCancel(err) || err.code === 'ERR_CANCELED') return;
        setProducts([]);
        setTotal(0);
        setError('Gagal memuat data. Periksa koneksi internet kamu lalu coba lagi.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [page, limit, search, reloadKey]);

  return { products, total, loading, error, reload };
}
